// Where the Microsoft-OAuth links point (#816).
//
// The API sets the OAuth state cookie on the host that serves /start, and
// Azure only knows the public callback. The /zeit/ build (Darkserver-App
// bridge) therefore starts the login on the public host in a new tab when
// VITE_PUBLIC_BASE_URL is baked in. The main build keeps navigating in place.

export interface OAuthLink {
  url: string
  newTab: boolean
}

/** Pure decision, testable without DOM or import.meta.env. `path` starts
 * with `/api/…` and may carry a query string. */
export function resolveOAuthLink(opts: {
  baseUrl: string
  publicBaseUrl: string | undefined
  apiBase: string
  path: string
}): OAuthLink {
  const publicOrigin = httpsOrigin(opts.publicBaseUrl)
  if (opts.baseUrl !== '/' && publicOrigin) {
    return { url: `${publicOrigin}${opts.path}`, newTab: true }
  }
  return { url: `${opts.apiBase}${opts.path}`, newTab: false }
}

function httpsOrigin(raw: string | undefined): string | undefined {
  if (!raw) return undefined
  try {
    const url = new URL(raw)
    return url.protocol === 'https:' ? url.origin : undefined
  } catch {
    return undefined
  }
}

/** resolveOAuthLink with this build's BASE_URL and VITE_PUBLIC_BASE_URL. */
export function oauthLink(apiBase: string, path: string): OAuthLink {
  return resolveOAuthLink({
    baseUrl: import.meta.env.BASE_URL,
    publicBaseUrl: import.meta.env.VITE_PUBLIC_BASE_URL,
    apiBase,
    path,
  })
}

export function openOAuthLink(link: OAuthLink): void {
  if (link.newTab) {
    window.open(link.url, '_blank', 'noopener,noreferrer')
  } else {
    window.location.href = link.url
  }
}
